import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";
import "../Content/CSS/FlightReview.css";
import AddonManager from "../AirResponse/AddonManager";
import PaymentSuccess from "../AirResponse/PaymentSuccess";

// ====================== CUSTOM DATE PICKER ======================
const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
const DAYS = ["Su","Mo","Tu","We","Th","Fr","Sa"];

const DatePickerInput = ({ value, onChange, placeholder = "DOB (DD/MM/YYYY)" }) => {
  const today = new Date();
  const parseVal = (v) => {
    if (!v) return null;
    const [d, m, y] = v.split("/");
    if (d && m && y) return new Date(+y, +m - 1, +d);
    return null;
  };
  const parsed = parseVal(value);
  const [open, setOpen] = useState(false);
  const [dropPos, setDropPos] = useState({ top: 0, left: 0, width: 280 });
  const [viewYear, setViewYear] = useState(parsed ? parsed.getFullYear() : today.getFullYear() - 25);
  const [viewMonth, setViewMonth] = useState(parsed ? parsed.getMonth() : today.getMonth());
  const [mode, setMode] = useState("day");
  const triggerRef = useRef(null);
  const dropRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (
        triggerRef.current && !triggerRef.current.contains(e.target) &&
        dropRef.current && !dropRef.current.contains(e.target)
      ) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);
useEffect(() => {
  localStorage.removeItem("mealSelection");
  localStorage.removeItem("baggageSelection");
  localStorage.removeItem("baggageSelectionChild");
}, []);
  useEffect(() => {
    if (!open) return;
    const reposition = () => {
      if (!triggerRef.current) return;
      const rect = triggerRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const top = spaceBelow > 300
        ? rect.bottom + window.scrollY + 6
        : rect.top + window.scrollY - 306;
      setDropPos({ top, left: rect.left + window.scrollX, width: Math.max(rect.width, 280) });
    };
    reposition();
    window.addEventListener("scroll", reposition, true);
    window.addEventListener("resize", reposition);
    return () => {
      window.removeEventListener("scroll", reposition, true);
      window.removeEventListener("resize", reposition);
    };
  }, [open]);

  const handleOpen = () => {
    if (!triggerRef.current) return;
    const rect = triggerRef.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const top = spaceBelow > 300
      ? rect.bottom + window.scrollY + 6
      : rect.top + window.scrollY - 306;
    setDropPos({ top, left: rect.left + window.scrollX, width: Math.max(rect.width, 280) });
    setOpen(o => !o);
    setMode("day");
  };

  const daysInMonth = (y, m) => new Date(y, m + 1, 0).getDate();
  const firstDay = (y, m) => new Date(y, m, 1).getDay();

  const selectDate = (d) => {
    const dd = String(d).padStart(2, "0");
    const mm = String(viewMonth + 1).padStart(2, "0");
    onChange(`${dd}/${mm}/${viewYear}`);
    setOpen(false);
    setMode("day");
  };

  const prevMonth = () => {
    if (viewMonth === 0) { setViewMonth(11); setViewYear(y => y - 1); }
    else setViewMonth(m => m - 1);
  };
  const nextMonth = () => {
    if (viewMonth === 11) { setViewMonth(0); setViewYear(y => y + 1); }
    else setViewMonth(m => m + 1);
  };

  const yearList = () => {
    const base = Math.floor(viewYear / 12) * 12;
    return Array.from({ length: 12 }, (_, i) => base + i);
  };

  const selectedDay = parsed && parsed.getFullYear() === viewYear && parsed.getMonth() === viewMonth
    ? parsed.getDate() : null;

  const cells = [];
  const fd = firstDay(viewYear, viewMonth);
  const dim = daysInMonth(viewYear, viewMonth);
  for (let i = 0; i < fd; i++) cells.push(null);
  for (let i = 1; i <= dim; i++) cells.push(i);

  const dropdown = (
    <div
      ref={dropRef}
      className="dp-dropdown"
      style={{ position: "absolute", top: dropPos.top, left: dropPos.left, width: dropPos.width, zIndex: 99999 }}
    >
      <div className="dp-header">
        <button className="dp-nav" onClick={(e) => { e.stopPropagation(); mode === "year" ? setViewYear(y => y - 12) : prevMonth(); }}>‹</button>
        <div className="dp-header-center">
          <span className="dp-month-label" onClick={(e) => { e.stopPropagation(); setMode(m => m === "month" ? "day" : "month"); }}>
            {mode === "year" ? `${yearList()[0]} – ${yearList()[11]}` : MONTHS[viewMonth]}
          </span>
          {mode !== "year" && (
            <span className="dp-year-label" onClick={(e) => { e.stopPropagation(); setMode(m => m === "year" ? "day" : "year"); }}>
              {viewYear}
            </span>
          )}
        </div>
        <button className="dp-nav" onClick={(e) => { e.stopPropagation(); mode === "year" ? setViewYear(y => y + 12) : nextMonth(); }}>›</button>
      </div>

      {mode === "day" && (
        <>
          <div className="dp-weekdays">
            {DAYS.map(d => <span key={d} className="dp-wday">{d}</span>)}
          </div>
          <div className="dp-grid">
            {cells.map((d, i) => (
              <button
                key={i}
                className={[
                  "dp-day",
                  d === null ? "dp-empty" : "",
                  d === selectedDay ? "dp-selected" : "",
                  d === today.getDate() && viewMonth === today.getMonth() && viewYear === today.getFullYear() ? "dp-today" : "",
                ].join(" ")}
                disabled={!d}
                onClick={(e) => { e.stopPropagation(); d && selectDate(d); }}
              >
                {d || ""}
              </button>
            ))}
          </div>
        </>
      )}

      {mode === "month" && (
        <div className="dp-month-grid">
          {MONTHS.map((m, i) => (
            <button key={m} className={`dp-month-cell${i === viewMonth ? " dp-selected" : ""}`}
              onClick={(e) => { e.stopPropagation(); setViewMonth(i); setMode("day"); }}>
              {m.slice(0, 3)}
            </button>
          ))}
        </div>
      )}

      {mode === "year" && (
        <div className="dp-month-grid">
          {yearList().map(y => (
            <button key={y} className={`dp-month-cell${y === viewYear ? " dp-selected" : ""}`}
              onClick={(e) => { e.stopPropagation(); setViewYear(y); setMode("day"); }}>
              {y}
            </button>
          ))}
        </div>
      )}
    </div>
  );

  return (
    <>
      <div ref={triggerRef} className="dp-wrap">
        <div
          className={`fr-input dp-display${open ? " dp-active" : ""}`}
          onClick={handleOpen}
          style={{ cursor: "pointer" }}
        >
          {value
            ? <span className="dp-val">{value}</span>
            : <span className="dp-placeholder">{placeholder}</span>
          }
          <span className="dp-icon">📅</span>
        </div>
      </div>
      {open && createPortal(dropdown, document.body)}
    </>
  );
};

// ====================== PASSPORT SECTION COMPONENT ======================
const PassportSection = ({ adult, index, onAdultChange }) => {
  return (
    <div className="fr-passport-section">
      <div className="fr-passport-header">
        <span className="fr-passport-icon">📕</span>
        <span className="fr-passport-title">Passport Details</span>
        <span className="fr-passport-required-badge">Required for International Travel</span>
      </div>

      <div className="fr-psrow" style={{ marginTop: "12px" }}>
        <div className="fr-pscol">
          <label className="fr-field-label">
            Passport Number <span className="fr-required-star">*</span>
          </label>
          <input
            className={`fr-input${!adult.passportNo ? " fr-input-empty" : ""}`}
            placeholder="e.g. A1234567"
            value={adult.passportNo}
            maxLength={20}
            onChange={(e) =>
              onAdultChange(index, "passportNo", e.target.value.toUpperCase())
            }
          />
        </div>

        <div className="fr-pscol">
          <label className="fr-field-label">
            Issue Date <span className="fr-required-star">*</span>
          </label>
          <DatePickerInput
            value={adult.passportIssue}
            onChange={(val) => onAdultChange(index, "passportIssue", val)}
            placeholder="Issue Date (DD/MM/YYYY)"
          />
        </div>

        <div className="fr-pscol">
          <label className="fr-field-label">
            Expiry Date <span className="fr-required-star">*</span>
          </label>
          <DatePickerInput
            value={adult.passportExpiry}
            onChange={(val) => onAdultChange(index, "passportExpiry", val)}
            placeholder="Expiry Date (DD/MM/YYYY)"
          />
        </div>

        <div className="fr-pscol">
          <label className="fr-field-label">
            Issuing Country <span className="fr-required-star">*</span>
          </label>
          <select
            className="fr-select"
            value={adult.countryCode || "IN"}
            onChange={(e) => onAdultChange(index, "countryCode", e.target.value)}
          >
            <option value="IN">India</option>
            <option value="US">USA</option>
            <option value="GB">UK</option>
            <option value="AE">UAE</option>
            <option value="SG">Singapore</option>
            <option value="AU">Australia</option>
            <option value="CA">Canada</option>
            <option value="DE">Germany</option>
            <option value="FR">France</option>
            <option value="JP">Japan</option>
            <option value="SA">Saudi Arabia</option>
            <option value="QA">Qatar</option>
            <option value="KW">Kuwait</option>
            <option value="OM">Oman</option>
            <option value="BH">Bahrain</option>
            <option value="NZ">New Zealand</option>
            <option value="ZA">South Africa</option>
            <option value="NG">Nigeria</option>
            <option value="PK">Pakistan</option>
            <option value="BD">Bangladesh</option>
            <option value="LK">Sri Lanka</option>
            <option value="NP">Nepal</option>
          </select>
        </div>
      </div>

      <div className="fr-passport-hint">
        ⚠️ Passport must be valid for at least 6 months from date of travel.
      </div>
    </div>
  );
};

// ====================== FLIGHT CONTRACT CARD ======================
const FlightContractCard = ({ contract }) => {
  const segs = contract.AirSegments || [];
  const firstSeg = segs[0];
  const lastSeg = segs[segs.length - 1];
  const totalStops = segs.length - 1;
  const stopLabel = totalStops === 0 ? "Non-stop" : `${totalStops} Stop${totalStops > 1 ? "s" : ""}`;

  const fmt = (d) => new Date(d).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  const fmtDate = (d) =>
    new Date(d).toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short", year: "2-digit" });

  return (
    <div className="fr-card">
      <div className="fr-contract-label">
        <span className="fr-contract-label-text">{contract.Label || "ONWORD"}</span>
        <span className="fr-contract-route">
          {firstSeg?.Origen} <span style={{ color: "#64748b" }}>→</span> {lastSeg?.Destination}
        </span>
        <span className="fr-contract-meta">
          {firstSeg?.DepartureDateTime
            ? new Date(firstSeg.DepartureDateTime).toLocaleDateString("en-IN", { day: "numeric", month: "short" })
            : ""}
          &nbsp;|&nbsp;{stopLabel}
        </span>
      </div>

      {segs.map((seg, si) => {
        const isLast = si === segs.length - 1;
        return (
          <React.Fragment key={si}>
            <div className="fr-seg-head">
              <span className={contract.Refundable ? "fr-badge-refund" : "fr-badge-norefund"}>
                {contract.Refundable ? "Refundable" : "Non Refundable"}
              </span>
              <span className="fr-fare-rules">Fare Rules ⓘ</span>
            </div>

            <div className="fr-seg-details">
              <div className="fr-airline-block">
                <div className="fr-airline-img">✈️</div>
                <div>
                  <div className="fr-airline-name">{seg.AirlineName}</div>
                  <div className="fr-airline-num">{seg.AirlineCode}-{seg.FlightNumber}</div>
                </div>
              </div>
              <div className="fr-detail-col">
                <span className="lbl">Travel Class</span>
                <span className="val">{seg.CabinClass || "Economy"}</span>
              </div>
              <div className="fr-detail-col">
                <span className="lbl">Check-In Baggage</span>
                <span className="val">Adult - {seg.BaggageAllowed?.CheckInBaggage || "15 Kg"} (01 Piece only)</span>
              </div>
              <div className="fr-detail-col">
                <span className="lbl">Cabin Baggage</span>
                <span className="val">Adult - {seg.BaggageAllowed?.HandBaggage || "7 Kg"}</span>
              </div>
            </div>

            <div className="fr-timing">
              <div className="fr-timing-end">
                <div className="big-time">{fmt(seg.DepartureDateTime)}</div>
                <div className="small-date">{fmtDate(seg.DepartureDateTime)}</div>
                <div className="airport">{seg.Origen} <span style={{ color: "#94a3b8" }}>[{seg.Origen}]</span></div>
                {seg.Terminal?.Dep && <div className="terminal">{seg.Terminal.Dep}</div>}
              </div>
              <div className="fr-duration">
                <span className="fr-dur-label">{seg.Duration}</span>
                <div className="fr-dur-line"><span className="fr-plane-icon">✈</span></div>
              </div>
              <div className="fr-timing-end">
                <div className="big-time">{fmt(seg.ArrivalDateTime)}</div>
                <div className="small-date">{fmtDate(seg.ArrivalDateTime)}</div>
                <div className="airport">{seg.Destination} <span style={{ color: "#94a3b8" }}>[{seg.Destination}]</span></div>
                {seg.Terminal?.Arr && <div className="terminal">{seg.Terminal.Arr}</div>}
              </div>
            </div>

            {!isLast && seg.LayoverDuration && (
              <div className="fr-layover">
                <span className="fr-layover-icon">🔄</span>
                <span className="fr-layover-main">
                  Change planes at <strong>{seg.Destination}</strong>. Layover Time:
                </span>
                <span className="fr-layover-time">{seg.LayoverDuration}</span>
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

// ====================== BOOKING PREVIEW OVERLAY ======================
const BookingPreviewOverlay = ({ formData, contracts, fare, passengerCount, onClose, onConfirm, isInternational, inr }) => {
  const fmt = (d) => new Date(d).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  const fmtDate = (d) =>
    new Date(d).toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short", year: "numeric" });

  return (
    <div className="bp-overlay">
      <div className="bp-modal">
        <div className="bp-header">
          <div className="bp-header-left">
            <span className="bp-header-icon">🎫</span>
            <div>
              <div className="bp-header-title">Booking Preview</div>
              <div className="bp-header-sub">Please review all details before confirming</div>
            </div>
          </div>
          <button className="bp-close" onClick={onClose}>✕</button>
        </div>

        <div className="bp-body">
          {contracts.map((contract, ci) => {
            const segs = contract.AirSegments || [];
            const firstSeg = segs[0];
            const lastSeg = segs[segs.length - 1];
            return (
              <div key={ci} className="bp-section">
                <div className="bp-section-title">
                  ✈️ {contract.Label || "ONWARD"} &nbsp;
                  <span className="bp-route-tag">
                    {firstSeg?.Origen} → {lastSeg?.Destination}
                  </span>
                </div>
                {segs.map((seg, si) => (
                  <div key={si} className="bp-flight-row">
                    <div className="bp-flight-airline">
                      <span className="bp-flight-icon">✈️</span>
                      <div>
                        <div className="bp-airline-name">{seg.AirlineName}</div>
                        <div className="bp-airline-code">{seg.AirlineCode}-{seg.FlightNumber} · {seg.CabinClass || "Economy"}</div>
                      </div>
                    </div>
                    <div className="bp-flight-timing">
                      <div className="bp-timing-block">
                        <div className="bp-time">{fmt(seg.DepartureDateTime)}</div>
                        <div className="bp-date">{fmtDate(seg.DepartureDateTime)}</div>
                        <div className="bp-airport">{seg.Origen}</div>
                      </div>
                      <div className="bp-flight-line">
                        <span className="bp-dur">{seg.Duration}</span>
                        <div className="bp-line">──✈──</div>
                      </div>
                      <div className="bp-timing-block">
                        <div className="bp-time">{fmt(seg.ArrivalDateTime)}</div>
                        <div className="bp-date">{fmtDate(seg.ArrivalDateTime)}</div>
                        <div className="bp-airport">{seg.Destination}</div>
                      </div>
                    </div>
                    <div className="bp-baggage">
                      <span>🧳 {seg.BaggageAllowed?.CheckInBaggage || "15 Kg"} Check-in</span>
                      <span>👜 {seg.BaggageAllowed?.HandBaggage || "7 Kg"} Cabin</span>
                    </div>
                  </div>
                ))}
              </div>
            );
          })}

          <div className="bp-section">
            <div className="bp-section-title">👤 Traveller Details</div>
            <div className="bp-travellers">
              {formData.adults.map((adult, i) => (
                <div key={i} className="bp-traveller-row">
                  <div className="bp-traveller-avatar">
                    {adult.firstName ? adult.firstName[0].toUpperCase() : "A"}
                  </div>
                  <div className="bp-traveller-info">
                    <div className="bp-traveller-name">
                      {adult.title && <span className="bp-title-badge">{adult.title}</span>}
                      {adult.firstName || <span className="bp-missing">First Name</span>}{""}
                      {adult.lastName || <span className="bp-missing">Last Name</span>}
                    </div>
                    <div className="bp-traveller-meta">
                      Adult {i + 1}
                      {adult.dob && <>&nbsp;·&nbsp;DOB: {adult.dob}</>}
                    </div>
                    {isInternational && adult.passportNo && (
                      <div className="bp-passport-preview">
                        <div className="bp-passport-preview-inner">
                          <span className="bp-pp-icon">📕</span>
                          <div className="bp-pp-details">
                            <div className="bp-pp-row">
                              <span className="bp-pp-lbl">Passport No:</span>
                              <span className="bp-pp-val"><strong>{adult.passportNo}</strong></span>
                            </div>
                            {adult.passportIssue && (
                              <div className="bp-pp-row">
                                <span className="bp-pp-lbl">Issue Date:</span>
                                <span className="bp-pp-val">{adult.passportIssue}</span>
                              </div>
                            )}
                            {adult.passportExpiry && (
                              <div className="bp-pp-row">
                                <span className="bp-pp-lbl">Expiry Date:</span>
                                <span className="bp-pp-val">{adult.passportExpiry}</span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    {isInternational && !adult.passportNo && (
                      <div className="bp-passport-missing">
                        ⚠️ Passport details missing
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bp-section">
            <div className="bp-section-title">📧 Contact Information</div>
            <div className="bp-contact-grid">
              <div className="bp-contact-item">
                <span className="bp-contact-lbl">📱 Phone</span>
                <span className="bp-contact-val">
                  {formData.contactNumber || <span className="bp-missing">Not provided</span>}
                </span>
              </div>
              <div className="bp-contact-item">
                <span className="bp-contact-lbl">✉️ Email</span>
                <span className="bp-contact-val">
                  {formData.email || <span className="bp-missing">Not provided</span>}
                </span>
              </div>
            </div>
          </div>

          {formData.gst?.gstin && (
            <div className="bp-section">
              <div className="bp-section-title">🧾 GST Details</div>
              <div className="bp-contact-grid">
                <div className="bp-contact-item">
                  <span className="bp-contact-lbl">GSTIN</span>
                  <span className="bp-contact-val">{formData.gst.gstin}</span>
                </div>
                <div className="bp-contact-item">
                  <span className="bp-contact-lbl">Company</span>
                  <span className="bp-contact-val">{formData.gst.companyName}</span>
                </div>
              </div>
            </div>
          )}

          <div className="bp-section">
            <div className="bp-section-title">💰 Fare Summary</div>
            <div className="bp-fare-table">
              <div className="bp-fare-row">
                <span>Base Fare ({passengerCount} Traveller{passengerCount > 1 ? "s" : ""})</span>
                <span>{inr(fare.BaseFare)}</span>
              </div>
              <div className="bp-fare-row">
                <span>Tax & Surcharge</span>
                <span>{inr(fare.TaxFare || fare.Tax)}</span>
              </div>
              {Number(fare.Discount || 0) > 0 && (
                <div className="bp-fare-row bp-fare-discount">
                  <span>Discount</span>
                  <span>- {inr(fare.Discount)}</span>
                </div>
              )}
              {Number(fare.AddOns || 0) > 0 && (
                <div className="bp-fare-row">
                  <span>Add-Ons</span>
                  <span>{inr(fare.AddOns)}</span>
                </div>
              )}
              <div className="bp-fare-total-row">
                <span>You Pay</span>
                <span>{inr(fare.GrossFare || (Number(fare.BaseFare || 0) + Number(fare.TaxFare || fare.Tax || 0)))}</span>
              </div>
            </div>
          </div>

          {formData.promoCode && (
            <div className="bp-promo-applied">
              🎉 Promo Code <strong>{formData.promoCode}</strong> applied
            </div>
          )}
        </div>

        <div className="bp-footer">
          <button className="bp-btn-back" onClick={onClose}>← Edit Details</button>
          <button className="bp-btn-confirm" onClick={onConfirm}>Confirm & Pay →</button>
        </div>
      </div>
    </div>
  );
};

// ====================== MAIN COMPONENT ======================
export default function FlightReview() {
  const [openAddon, setOpenAddon] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const stateData = location.state || {};
  const sellResponse = stateData.sellResponse;
  const flight = stateData.flight || stateData.FareDetail || stateData;

  const adultCount = stateData?.AdultCount || flight?.AdultCount || 1;
  const childCount = stateData?.ChildCount || flight?.ChildCount || 0;
  const infantCount = stateData?.InfantCount || flight?.InfantCount || 0;
  const passengerCount = adultCount + childCount + infantCount;

  // ✅ Live INR → AED exchange rate
  const [inrToAed, setInrToAed] = useState(null);

  useEffect(() => {
    const fetchRate = async () => {
      const cached = localStorage.getItem("inrToAedRate");
      const cachedAt = localStorage.getItem("inrToAedRateTime");
      const CACHE_DURATION_MS = 30 * 24 * 60 * 60 * 1000;

      if (cached && cachedAt && Date.now() - Number(cachedAt) < CACHE_DURATION_MS) {
        setInrToAed(Number(cached));
        return;
      }

      try {
        const res = await fetch(
          `https://v6.exchangerate-api.com/v6/${process.env.REACT_APP_EXCHANGE_API_KEY}/latest/INR`
        );
        const data = await res.json();
        const rate = data?.conversion_rates?.AED;
        if (rate) {
          setInrToAed(rate);
          localStorage.setItem("inrToAedRate", rate);
          localStorage.setItem("inrToAedRateTime", Date.now().toString());
        }
      } catch (err) {
        console.error("Exchange rate fetch failed:", err.message);
      }
    };
    fetchRate();
  }, []);

  const AedIcon = () => <span style={{ fontFamily: "sans-serif" }}>&#xea;</span>;

  const formatPrice = (inrAmount) => {
    const amt = Number(inrAmount || 0);
    if (!inrToAed) return <>...</>;
    const aedValue = (amt * inrToAed).toFixed(2);
    return (
      <>
        <AedIcon /> {Number(aedValue).toLocaleString("en-AE")}
      </>
    );
  };

  const [formData, setFormData] = useState({
    adults: [],
    children: [],
    infants: [],
    contactNumber: "",
    email: "",
    promoCode: "",
    gst: {
      gstin: "",
      companyName: "",
      mobile: "",
      email: "",
      address: "",
    },   
  });

  const [addonTotal, setAddonTotal] = useState(0);
  const [seatTotal, setSeatTotal] = useState(0);
  const [mealTotal, setMealTotal] = useState(0);
  const [baggageTotal, setBaggageTotal] = useState(0);
  const [seatSelections, setSeatSelections] = useState([]);
  const [mealSelections, setMealSelections] = useState({});
  const [baggageSelections, setBaggageSelections] = useState({});
  const [gstOpen, setGstOpen] = useState(false);

  const INDIAN_AIRPORTS = [
    "DEL", "BOM", "MAA", "CCU", "BLR", "HYD", "COK", "AMD", "PNQ", "GOI",
    "JAI", "LKO", "NAG", "PAT", "IXC", "ATQ", "BHO", "IDR", "VNS", "GAU",
    "IXR", "SXR", "TRV", "IXB", "IXM", "DIB", "JDH", "UDR", "IXA", "RPR",
    "VTZ", "BBI", "STV", "IXE", "IXL", "CCJ", "IXJ", "IXS", "IXU", "PNY",
    "HBX", "KNU", "AGR", "GWL", "JLR", "JGA", "RAJ", "BDQ", "VGA", "TIR"
  ];

  let contracts = [];

  if (sellResponse?.Sell?.Contracts?.length > 0) {
    contracts = sellResponse.Sell.Contracts;
  } else if (flight?.AirSegments || flight?.Sell?.Contracts) {
    contracts = flight.Sell?.Contracts || [
      {
        Label: "ONWORD",
        Refundable: flight?.AirlineFare?.Refundable ?? true,
        AirlineFare: flight?.AirlineFare || {},
        AirSegments: flight?.AirSegments || [],
      },
    ];
  }

  const segments = flight?.AirSegments || contracts?.[0]?.AirSegments || [];
  const isInternational = segments.some(seg =>
    !INDIAN_AIRPORTS.includes(seg?.Origen) ||
    !INDIAN_AIRPORTS.includes(seg?.Destination)
  ) && !flight?.IsDomestic;

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      adults: Array(adultCount).fill(null).map(() => ({
        title: "", firstName: "", lastName: "", dob: "",
        passportNo: "", passportIssue: "", passportExpiry: "", countryCode: "IN"
      })),
      children: Array(childCount).fill(null).map(() => ({
        title: "Master",
        firstName: "", lastName: "", dob: "",
        passportNo: "", passportIssue: "", passportExpiry: "", countryCode: "IN"
      })),
      infants: Array(infantCount).fill(null).map(() => ({
        title: "Master",
        firstName: "",
        lastName: "",
        dob: "",
        passportNo: "", passportIssue: "", passportExpiry: "", countryCode: "IN"
      })),
    }));
  }, [adultCount, childCount, infantCount]);

  if (contracts.length === 0) {
    return <div style={{ padding: "80px", textAlign: "center" }}>No Flight Data Found</div>;
  }

  const fare = contracts[0]?.AirlineFare || {};

  const handleAdultChange = (index, field, value) => {
    const updated = formData.adults.map((a, i) => (i === index ? { ...a, [field]: value } : a));
    setFormData({ ...formData, adults: updated });
  };

  const handleChildChange = (index, field, value) => {
    const updated = formData.children.map((c, i) => (i === index ? { ...c, [field]: value } : c));
    setFormData({ ...formData, children: updated });
  };

  const handleInfantChange = (index, field, value) => {
    const updated = formData.infants.map((c, i) => (i === index ? { ...c, [field]: value } : c));
    setFormData({ ...formData, infants: updated });
  };

  const handleGstChange = (field, value) => {
    setFormData({ ...formData, gst: { ...formData.gst, [field]: value } });
  };

  const handleBookingPreview = () => {
    for (let i = 0; i < formData.adults.length; i++) {
      const pax = formData.adults[i];
      if (!pax.title?.trim()) {
        alert(`Adult ${i + 1}: Title is required`); return;
      }
      if (!pax.firstName?.trim()) {
        alert(`Adult ${i + 1}: First Name is required`);
        return;
      }
      if (!pax.lastName?.trim()) {
        alert(`Adult ${i + 1}: Last Name is required`);
        return;
      }
    }

    for (let i = 0; i < formData.children.length; i++) {
      const pax = formData.children[i];
      if (!pax.title) { alert(`Child ${i + 1}: Title is required`); return; }
      if (!pax.firstName?.trim()) { alert(`Child ${i + 1}: First Name is required`); return; }
      if (!pax.lastName?.trim()) { alert(`Child ${i + 1}: Last Name is required`); return; }
      if (isInternational && !pax.passportNo?.trim()) {
        alert(`Child ${i + 1}: Passport Number is required`); return;
      }
    }

    for (let i = 0; i < formData.infants.length; i++) {
      const pax = formData.infants[i];
      if (!pax.title) { alert(`Infant ${i + 1}: Title is required`); return; }
      if (!pax.firstName?.trim()) { alert(`Infant ${i + 1}: First Name is required`); return; }
      if (!pax.lastName?.trim()) { alert(`Infant ${i + 1}: Last Name is required`); return; }
      if (!pax.dob) { alert(`Infant ${i + 1}: Date of Birth is required`); return; }
    }

    if (isInternational) {
      for (let i = 0; i < formData.adults.length; i++) {
        const pax = formData.adults[i];
        if (!pax.passportNo?.trim()) {
          alert(`Adult ${i + 1}: Passport Number is required for international travel`);
          return;
        }
        if (!pax.passportIssue) {
          alert(`Adult ${i + 1}: Passport Issue Date is required`);
          return;
        }
        if (!pax.passportExpiry) {
          alert(`Adult ${i + 1}: Passport Expiry Date is required`);
          return;
        }
      }
    }

    setShowPreview(true);
  };

  const redirectToTelr = async ({ bookingId, amount, firstName, lastName, email, phone, productInfo }) => {
    try {
      const response = await fetch("https://booking.bookbyown.ae/api/create-telr-order", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ bookingId, amount, firstName, lastName, email, phone, productInfo }),
      });
      // const response = await fetch("http://localhost:3000/api/create-telr-order", {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify({ bookingId, amount, firstName, lastName, email, phone, productInfo }),
      // });

      const data = await response.json();

      if (data?.url) {
        window.location.href = data.url;
      } else {
        console.error("❌ Telr order creation failed:", data?.error);
        alert("Payment gateway error: " + (data?.error || "Could not create payment order"));
      }
    } catch (err) {
      console.error("❌ create-telr-order request failed:", err);
      alert("Something went wrong while starting payment. Please try again.");
    }
  };
   const handleConfirmPayment = async () => {
    try {
      const apiToken = sellResponse?.APIToken || flight?.APIToken || "";
      const agencyKey = sellResponse?.AgencyKey || flight?.AgencyKey || "4AC0F2DD-66C2-4AC1-8AFD-DE615E223A4A";
      const bookingKey = sellResponse?.BookingKey || flight?.BookingKey || "";
      const contractId = contracts.map(c => c.ContractId).filter(Boolean).join("^");
      const netPrice = contracts.reduce((sum, c) => {
      const f = c.AirlineFare || {};
      return sum + Number(f.GrossFare || (Number(f.BaseFare || 0) + Number(f.TaxFare || f.Tax || 0)));
      }, 0) + Number(seatTotal || 0) + Number(mealTotal || 0) + Number(baggageTotal || 0);
      const allPexFares = contracts.flatMap(c => c.PexFareDetails || []); 
      const getPaxFare = (paxType) => {
        
        const fares = allPexFares.filter(p => p.PaxType === paxType);
        const totPax = fares[0]?.TotPax || 1;
        return {
          BaseFare: fares.length ? fares.reduce((s, f) => s + Number(f.BaseFare || 0), 0) / totPax : Number(fare.BaseFare || 0),
          TaxFare: fares.length ? fares.reduce((s, f) => s + Number(f.TaxFare || 0), 0) / totPax : Number(fare.TaxFare || fare.Tax || 0),
          YQTax: fares.length ? fares.reduce((s, f) => s + Number(f.YQTax || 0), 0) / totPax : 0,
          TotPax: totPax,
        };
      };

      const fmtPassportDate = (val) => val ? val.replace(/\//g, "-") : null;

      const getDefaultTitle = (paxType) => {
        if (paxType === 1) return "Mr";
        if (paxType === 2) return "Master";
        if (paxType === 3) return "Master";
        return "Mr";
      };

      const buildPax = (pax, paxType, fareInfo, isLead = false, paxIndex = 0) => {
        const paxKeyType = paxType === 1 ? "adult" : paxType === 2 ? "child" : "infant";
 
        let sortedSeats = [];
        if (paxType === 1) {
          const segmentIndexes = [...new Set(seatSelections.map((s) => s.segmentIndex))];
          sortedSeats = segmentIndexes
            .map((segIdx) => {
              const seatsInSeg = seatSelections
                .filter((s) => s.segmentIndex === segIdx)
                .sort((a, b) => (a.seatCode || "").localeCompare(b.seatCode || ""));
              return seatsInSeg[paxIndex] || null;
            })
            .filter(Boolean)
            .sort((a, b) => {
              const aIdx = contracts.findIndex((c) => c.ContractId === a.contractId);
              const bIdx = contracts.findIndex((c) => c.ContractId === b.contractId);
              return aIdx - bIdx;
            });
        }
 
        const seatCode = sortedSeats.length > 0 ? sortedSeats.map((s) => s.seatCode || "").join("|") : null;
        const seatFare = sortedSeats.reduce((sum, s) => sum + Number(s.seatPrice || 0), 0);
 
     const mealObj = mealSelections[`${paxKeyType}-${paxIndex + 1}-onward`];
const mealCode = mealObj?.Code && String(mealObj.Code).trim() 
  ? String(mealObj.Code).trim() 
  : null;
const mealFare = Number(mealObj?.MealAmount || 0);

const baggageObj = baggageSelections[`${paxKeyType}-${paxIndex + 1}`];
const baggageCode = baggageObj?.Code && String(baggageObj.Code).trim() 
  ? String(baggageObj.Code).trim() 
  : null;
const baggageFare = Number(baggageObj?.Price || 0);
 
        return {
          PaxId: null,
          Tital: pax.title?.trim() || getDefaultTitle(paxType),
          Title: pax.title?.trim() || getDefaultTitle(paxType),
          FirstName: pax.firstName?.trim() || "",
          LastName: pax.lastName?.trim() || "",
          PaxType: paxType,
          Gender: null,
          DateOfBirth: fmtPassportDate(pax.dob) || null,
          PassportNo: pax.passportNo?.trim() || null,
          PassportIssue: fmtPassportDate(pax.passportIssue) || null,
          PassportExpiry: fmtPassportDate(pax.passportExpiry) || null,
          ContryCode: pax.countryCode || null,
          ContactNo: formData.contactNumber?.trim() || "",
          Email: formData.email?.trim() || "",
          PaxFare: {
            BaseFare: fareInfo.BaseFare,
            TaxFare: fareInfo.TaxFare,
            YQTax: fareInfo.YQTax,
            PaxType: paxType,
            TotPax: fareInfo.TotPax,
            PriceBaggage: baggageFare,
            PriceMeal: mealFare,
            PriceSeat: seatFare,
          },
          APIGST: null,
          IsLeadPax: isLead,
          MealCode: mealCode,
          BaggageCode: baggageCode,
          SeatCode: seatCode,
          FrequentFlNo: null,
          TicketNumber: null,
        };
      };
      const passengers = [
        ...formData.adults.map((pax, i) => buildPax(pax, 1, getPaxFare(1), i === 0, i)),
        ...(formData.children || []).map((pax, i) => buildPax(pax, 2, getPaxFare(2), false, i)),
        ...(formData.infants || []).map((pax, i) => buildPax(pax, 3, getPaxFare(3), false, i)),
      ];

      const apiGST = formData.gst?.gstin ? {
        GSTNNumber: formData.gst.gstin,
        GSTCompanyName: formData.gst.companyName,
        GSTCompanyContact: formData.gst.mobile,
        GSTCompanyEmailId: formData.gst.email,
        GSTCompanyAddress: formData.gst.address,
      } : null;

      const payload = {
        AirlinePnr: null,
        APIToken: apiToken,
        AgencyKey: agencyKey,
        BookingKey: bookingKey,
        ContractId: contractId,
        Flightpassenger: passengers,
        BookingId: String(Math.floor(Math.random() * 999799) + 200),
        AccountNo: "17",
        TxnId: null,
        PaxFare: null,
        APIGST: apiGST,
        PaymentStatus: null,
        UserKey: "",
        IsB2B: false,
        IsHoldRequest: false,
        IsTC: true,
        NetPrice: netPrice,
      };

      const response = await fetch("https://promo.namantechnolab.com/api/Trip/BookFlight", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      setShowPreview(false);

      if (data?.ResponseStatus === 1 && data?.BookingId) {
        sessionStorage.setItem("lastBookingId", data.BookingId);
        sessionStorage.setItem("lastUserKey", data.UserKey || "");
        const leadPassenger = formData.adults[0] || {};
        const gatewayCartId = `${data.BookingId}_${Date.now()}`;
        const netPriceInr = netPrice || fare.GrossFare;
  if (!inrToAed) {
    alert("Exchange Currency not load please try again after some time");
    return;
  }
       const finalAmount = Number((netPriceInr * inrToAed).toFixed(2));
        sessionStorage.setItem("lastAmount", finalAmount);
        sessionStorage.setItem("lastAmountCurrency", "AED");

        const telrPaymentRequest = {
          GatewayPrice: 0.0,
          Error: null,
          GatewayStatus: null,
          GatewayKey: "TELR",
          GatewayOrderId: null,
          UserKey: data.UserKey || "",
          BookingId: gatewayCartId,
          PaxFirstName: leadPassenger.firstName || "Customer",
          PaxLastName: leadPassenger.lastName || "",
          PaxEmailId: formData.email || "noreply@example.com",
          PaxMobileNo: formData.contactNumber || null,
          Amount: Number(finalAmount).toFixed(2),
          ProductInfo: "Flight",
          Surl: `https://booking.bookbyown.ae/payment-success?bookingId=${data.BookingId}`,
          Furl: `https://booking.bookbyown.ae/payment-failure?bookingId=${data.BookingId}`,
          Hash: null,
          BookingKey: bookingKey || "",
          udf1: data.UserKey || "",
          udf2: bookingKey || "",
        };

        const updateGatewayPayload = {
          TransactionId: Number(data.BookingId),
          Price: Number(finalAmount),
          GatewayCharge: 0,
          PaymentRequest: JSON.stringify(telrPaymentRequest),
          OrderId: String(data.BookingId),
          UserKey: data.UserKey || "",
          BookingType: 0,
          AgencyKey: agencyKey,
          AccountNo: 17,
        };

        try {
          const gwResponse = await fetch("https://promo.namantechnolab.com/api/Accounts/UpdateGatewayRQ", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updateGatewayPayload),
          });
          await gwResponse.json();
        } catch (gwErr) {
          console.error("❌ UpdateGatewayRQ Error:", gwErr);
        }

        redirectToTelr({
          bookingId: data.BookingId,
          amount: finalAmount,
          firstName: leadPassenger.firstName || "Customer",
          lastName: leadPassenger.lastName || "",
          email: formData.email || "noreply@example.com",
          phone: formData.contactNumber || "9999999999",
          productInfo: "Flight Booking",
        });
      } else {
        alert("Booking failed: " + (data?.Error?.ErrorDesc || "Unknown error"));
      }
    } catch (err) {
      console.error("❌ BookFlight Error:", err);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="fr-root">
      {showPreview && (
        <BookingPreviewOverlay
          formData={formData}
          contracts={contracts}
          fare={fare}
          passengerCount={passengerCount}
          isInternational={isInternational}
          onClose={() => setShowPreview(false)}
          onConfirm={handleConfirmPayment}
          inr={formatPrice}
        />
      )}

      <div className="fr-container">
        <div className="fr-page-header">
          <span className="fr-section-title" style={{ marginBottom: 0 }}>
            Review your flight details
          </span>
          <button className="fr-btn-back" onClick={() => navigate(-1)}>
            ← Back to Search
          </button>
        </div>

        <div className="fr-grid">
          <div>
            {contracts.map((contract, ci) => (
              <FlightContractCard key={ci} contract={contract} />
            ))}

            <span className="fr-section-title">Traveller Details</span>

            {isInternational && (
              <div className="fr-intl-notice">
                🌍 <strong>International Flight:</strong> Passport details are mandatory for all travellers.
                Passport must be valid for at least 6 months from the date of travel.
              </div>
            )}

            <div className="fr-card" style={{ padding: "16px" }}>
              <div className="fr-info-msg">
                ⓘ Please make sure that the name entered is exactly as per traveller's passport or government ID.
              </div>

              {formData.adults.map((adult, index) => (
                <div key={index} className="fr-traveller">
                  <div className="fr-traveller-head">👤 Adult {index + 1}</div>
                  <div className="fr-traveller-body">
                    <div className="fr-psrow">
                      <div className="fr-pscol-sm">
                        <label className="fr-field-label">Title</label>
                        <select
                          className="fr-select"
                          value={adult.title}
                          onChange={(e) => handleAdultChange(index, "title", e.target.value)}
                        >
                          <option value="">Title</option>
                          <option>Mr</option>
                          <option>Ms</option>
                          <option>Mrs</option>
                        </select>
                      </div>
                      <div className="fr-pscol">
                        <label className="fr-field-label">
                          First Name <span className="fr-required-star">*</span>
                        </label>
                        <input
                          className="fr-input"
                          placeholder="First Name"
                          value={adult.firstName}
                          onChange={(e) => handleAdultChange(index, "firstName", e.target.value)}
                        />
                      </div>
                      <div className="fr-pscol">
                        <label className="fr-field-label">
                          Last Name <span className="fr-required-star">*</span>
                        </label>
                        <input
                          className="fr-input"
                          placeholder="Last Name"
                          value={adult.lastName}
                          onChange={(e) => handleAdultChange(index, "lastName", e.target.value)}
                        />
                      </div>
                      <div className="fr-pscol">
                        <label className="fr-field-label">Date of Birth</label>
                        <DatePickerInput
                          value={adult.dob}
                          onChange={(val) => handleAdultChange(index, "dob", val)}
                          placeholder="DOB (DD/MM/YYYY)"
                        />
                      </div>
                    </div>

                    {isInternational && (
                      <PassportSection
                        adult={adult}
                        index={index}
                        onAdultChange={handleAdultChange}
                      />
                    )}
                  </div>
                </div>
              ))}

              {formData.children.map((child, index) => (
                <div key={index} className="fr-traveller">
                  <div className="fr-traveller-head">🧒 Child {index + 1}</div>
                  <div className="fr-traveller-body">
                    <div className="fr-psrow">
                      <div className="fr-pscol-sm">
                        <label className="fr-field-label">Title</label>
                        <select
                          className="fr-select"
                          value={child.title}
                          onChange={(e) => handleChildChange(index, "title", e.target.value)}
                        >
                          <option>Master</option>
                          <option>Miss</option>
                        </select>
                      </div>
                      <div className="fr-pscol">
                        <label className="fr-field-label">First Name <span className="fr-required-star">*</span></label>
                        <input
                          className="fr-input"
                          placeholder="First Name"
                          value={child.firstName}
                          onChange={(e) => handleChildChange(index, "firstName", e.target.value)}
                        />
                      </div>
                      <div className="fr-pscol">
                        <label className="fr-field-label">Last Name <span className="fr-required-star">*</span></label>
                        <input
                          className="fr-input"
                          placeholder="Last Name"
                          value={child.lastName}
                          onChange={(e) => handleChildChange(index, "lastName", e.target.value)}
                        />
                      </div>
                      <div className="fr-pscol">
                        <label className="fr-field-label">Date of Birth</label>
                        <DatePickerInput
                          value={child.dob}
                          onChange={(val) => handleChildChange(index, "dob", val)}
                          placeholder="DOB (DD/MM/YYYY)"
                        />
                      </div>
                    </div>
                    {isInternational && (
                      <PassportSection
                        adult={child}
                        index={index}
                        onAdultChange={handleChildChange}
                      />
                    )}
                  </div>
                </div>
              ))}

              {formData.infants.map((infant, index) => (
                <div key={index} className="fr-traveller">
                  <div className="fr-traveller-head">👶 Infant {index + 1}</div>
                  <div className="fr-traveller-body">
                    <div className="fr-psrow">
                      <div className="fr-pscol-sm">
                        <label className="fr-field-label">Title</label>
                        <select
                          className="fr-select"
                          value={infant.title}
                          onChange={(e) => handleInfantChange(index, "title", e.target.value)}
                        >
                          <option value="Master">Master</option>
                          <option value="Miss">Miss</option>
                        </select>
                      </div>
                      <div className="fr-pscol">
                        <label className="fr-field-label">First Name <span className="fr-required-star">*</span></label>
                        <input
                          className="fr-input"
                          placeholder="First Name"
                          value={infant.firstName}
                          onChange={(e) => handleInfantChange(index, "firstName", e.target.value)}
                        />
                      </div>
                      <div className="fr-pscol">
                        <label className="fr-field-label">Last Name <span className="fr-required-star">*</span></label>
                        <input
                          className="fr-input"
                          placeholder="Last Name"
                          value={infant.lastName}
                          onChange={(e) => handleInfantChange(index, "lastName", e.target.value)}
                        />
                      </div>
                      <div className="fr-pscol">
                        <label className="fr-field-label">Date of Birth <span className="fr-required-star">*</span></label>
                        <DatePickerInput
                          value={infant.dob}
                          onChange={(val) => handleInfantChange(index, "dob", val)}
                          placeholder="DOB (DD/MM/YYYY)"
                        />
                      </div>
                    </div>
                    {isInternational && (
                      <PassportSection
                        adult={infant}
                        index={index}
                        onAdultChange={handleInfantChange}
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className="fr-card">
              <div className="fr-contact-head">📧 Your ticket and flight information will be sent here</div>
              <div className="fr-pad">
                <div className="fr-psrow">
                  <div className="fr-pscol">
                    <input
                      className="fr-input"
                      placeholder="Contact Number"
                      value={formData.contactNumber}
                      onChange={(e) => setFormData({ ...formData, contactNumber: e.target.value })}
                    />
                  </div>
                  <div className="fr-pscol">
                    <input
                      className="fr-input"
                      placeholder="Email Address"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="fr-card">
              <div className="fr-gst-toggle" onClick={() => setGstOpen(!gstOpen)}>
                <div className="fr-gst-left">
                  🧾 Use GSTIN for this booking{" "}
                  <span style={{ color: "#7a8ba0", fontWeight: 400 }}>(Optional)</span>
                </div>
                <span className={`fr-gst-chevron${gstOpen ? " open" : ""}`}>▼</span>
              </div>
              {gstOpen && (
                <div className="fr-gst-body">
                  <hr className="fr-divider" style={{ marginBottom: 4 }} />
                  <div className="fr-psrow">
                    <div className="fr-pscol">
                      <input
                        className="fr-input"
                        placeholder="GSTIN Number"
                        value={formData.gst.gstin}
                        onChange={(e) => handleGstChange("gstin", e.target.value)}
                      />
                    </div>
                    <div className="fr-pscol">
                      <input
                        className="fr-input"
                        placeholder="Company Name"
                        value={formData.gst.companyName}
                        onChange={(e) => handleGstChange("companyName", e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="fr-psrow">
                    <div className="fr-pscol">
                      <input
                        className="fr-input"
                        placeholder="Mobile"
                        value={formData.gst.mobile}
                        onChange={(e) => handleGstChange("mobile", e.target.value)}
                      />
                    </div>
                    <div className="fr-pscol">
                      <input
                        className="fr-input"
                        placeholder="Email"
                        value={formData.gst.email}
                        onChange={(e) => handleGstChange("email", e.target.value)}
                      />
                    </div>
                  </div>
                  <input
                    className="fr-input"
                    placeholder="Company Address"
                    value={formData.gst.address}
                    onChange={(e) => handleGstChange("address", e.target.value)}
                  />
                </div>
              )}
            </div>

            <div className="fr-card">
              <div className="fr-addon-row">
                <div className="fr-addon-btn" onClick={() => setOpenAddon("seat")} style={{ cursor: "pointer" }}>
                  💺 Seat Selection
                </div>
                <div className="fr-addon-btn" onClick={() => setOpenAddon("meal")} style={{ cursor: "pointer" }}>
                  🍽️ Add Meals
                </div>
                <div className="fr-addon-btn" onClick={() => setOpenAddon("baggage")} style={{ cursor: "pointer" }}>
                  🧳 Add Baggage
                </div>
              </div>

              <AddonManager
                contractId={contracts?.[0]?.ContractId}
                returnContractId={contracts?.[1]?.ContractId}
                apiToken={sellResponse?.APIToken || flight?.APIToken || ""}
                bookingKey={sellResponse?.BookingKey || flight?.BookingKey || ""}
                isInternational={isInternational}
                isB2C={true}
                grossPrice={fare?.GrossFare || 0}
                adultCount={adultCount}
                childCount={childCount}
                discount={fare?.Discount || 0}
                passengerCount={adultCount + childCount}
                inrToAed={inrToAed}
                onAddonTotalChange={setAddonTotal}
                onSeatPriceChange={setSeatTotal}
                onMealPriceChange={setMealTotal}
                onBaggagePriceChange={setBaggageTotal}
                onSeatSelectionChange={setSeatSelections}
                onMealSelectionChange={setMealSelections}
                onBaggageSelectionChange={setBaggageSelections}
                openPanel={openAddon}
                onPanelChange={setOpenAddon}
                showInternalButtons={false}
              />
            </div>

            <div className="fr-pay-wrap">
              <button className="fr-btn-pay" onClick={handleBookingPreview}>
                Booking Preview
              </button>
            </div>
          </div>

          <div>
            <span className="fr-section-title">Fare Summary</span>
            <div className="fr-fare-panel">
              <div className="fr-fare-head">Price Breakdown</div>
              <div className="fr-fare-row">
                <span>Base Fare ({passengerCount} Traveller{passengerCount > 1 ? "s" : ""})</span>
                <span>{formatPrice(fare.BaseFare)}</span>
              </div>
              <div className="fr-fare-row">
                <span>Tax</span>
                <span>{formatPrice(fare.TaxFare || fare.Tax)}</span>
              </div>
              <div className="fr-fare-row">
                <span>Discount</span>
                <span>- {formatPrice(fare.Discount)}</span>
              </div>
              <div className="fr-fare-row">
                <span>Total Fare</span>
                <span>
                  {formatPrice(fare.GrossFare || Number(fare.BaseFare || 0) + Number(fare.TaxFare || fare.Tax || 0))}
                </span>
              </div>

              {seatTotal > 0 && (
                <div className="fr-fare-row">
                  <span>💺 Seat Selection</span>
                  <span>{formatPrice(seatTotal)}</span>
                </div>
              )}

              {mealTotal > 0 && (
                <div className="fr-fare-row">
                  <span>🍽️ Meals</span>
                  <span>{formatPrice(mealTotal)}</span>
                </div>
              )}

              {baggageTotal > 0 && (
                <div className="fr-fare-row">
                  <span>🧳 Baggage</span>
                  <span>{formatPrice(baggageTotal)}</span>
                </div>
              )}

              <div className="fr-fare-total">
                <span>You Pay :</span>
                <span>
                  {formatPrice(
                    (fare.GrossFare || Number(fare.BaseFare || 0) + Number(fare.TaxFare || fare.Tax || 0)) + addonTotal
                  )}
                </span>
              </div>
            </div>

            <span className="fr-section-title">Promo Code</span>
            <div className="fr-promo-panel">
              <div className="fr-promo-head">Apply Promo Code</div>
              <div className="fr-promo-body">
                <input
                  className="fr-promo-input"
                  placeholder="Enter promo code"
                  value={formData.promoCode}
                  onChange={(e) => setFormData({ ...formData, promoCode: e.target.value })}
                />
                <button className="fr-btn-promo" onClick={() => alert("Promo Applied!")}>
                  Apply
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}